import { useMemo, memo, useCallback } from 'react';
import clsx from 'clsx';

// Imports => Constants
import {ICONS} from '@opp/ui-kit';

// Imports => Atoms
import {AcButton, AcIcon} from '@opp/ui-kit';
import {withTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";

const _CLASSES = {
  MAIN: 'ac-notice ac-pending-compliance-requirement-notice',
  READY: 'ac-notice--ready',
};

const AcPendingComplianceRequirementNotice = ({data, t}) => {
  const history = useHistory();

  const isReady = useMemo(() => {
    return data;
  }, [data]);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, isReady && _CLASSES.READY);
  }, [isReady]);

  const goToProfileDetails = useCallback(
    () => {
      const {replace} = history;
      replace('/profile#details');
    }, []
  );

  return (
    <header
      id={'ac-pending-compliance-requirement-notice'}
      className={getMainClassNames}
      onClick={goToProfileDetails}
    >
      <AcIcon icon={ICONS.ALERT_OCTAGRAM_OUTLINE} />
      {t('pending-compliance-requirements', 'There are pending compliance requirements awaiting to be verified', {ns: 'common'})}
      <AcButton onClick={goToProfileDetails}>
        <span>{t('click-here-to-check', 'Click here to check', {ns: 'common'})}</span>
        <AcIcon icon={ICONS.OPEN_IN_NEW} />
      </AcButton>
    </header>
  );
};

export default withTranslation(['common'])(memo(AcPendingComplianceRequirementNotice));
